import React, { useEffect, useState, useContext } from "react";
import ContextApp from "../../../core/contexts/context.app";
import { Button, Col, Row } from "react-bootstrap";
import SplitNumber from "../_Components/SplitNumber";
import ApiAgent from "../../../core/api/api.agent";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";
import {
  IconCard,
  IconMoney,
  IconOrder,
  IconTicketPaper,
  IconWallet,
} from "../../../_metronic/css/icons";

export default function Payment() {
  const ctx = useContext(ContextApp);
  const navigate = useNavigate();
  const [dashboardData, setDashboardData] = useState({});
  const [isLoadingData, setIsLoadingData] = useState(true);
  useEffect(() => {
    (async () => {
      try {
        const data = await ApiAgent.getAgentDashboard();
        setDashboardData(data.data);
        setIsLoadingData(false);
      } catch (error) {
        setIsLoadingData(false);
      } finally {
      }
    })();
    return () => {};
  }, []);

  const handleGotoAfterPay = () => {
    navigate("/afterPay");
  };
  /************************************ */
  return ctx.basketInfo?.basketItemTemps?.length > 0 ? (
    <SkeletonTheme>
      <div className={`card card-custom rounded-4`}>
        <div className="card-header py-4">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              خلاصه سبد خرید و ثبت نهایی
            </span>
            <span className="text-muted mt-3 font-size-sm">
              اطلاعات زیر، خلاصه سبد خرید شماست. برای ثبت نهایی سفارش روی دکمه
              کلیک نمایید.
            </span>
          </h3>
        </div>
        <div className="card-body">
          <Row>
            <Col
              xs="12"
              sm="4"
              md
              lg="4"
              xl
              className="text-center mb-3 mb-sm-5 mb-xl-0"
            >
              <div className="border rounded-4 p-3 bg-light-warning border-light-warning">
                <div className="mb-4" style={{ height: "46px" }}>
                  <IconOrder width="42px" className="text-warning opacity-50" />
                </div>
                <div className=" mb-4 ">تعداد تفریحات</div>
                <div className="fw-bold fs-medium pb-2">
                  {isLoadingData ? (
                    <Skeleton width="40px" height="15px"></Skeleton>
                  ) : (
                    ctx.basketInfo?.basketItemTemps?.length
                  )}
                </div>
              </div>
            </Col>
            <Col
              xs="12"
              sm="4"
              md
              lg="4"
              xl
              className="text-center mb-3  mb-sm-5 mb-xl-0"
            >
              <div className="border rounded-4 p-3 bg-light-warning border-light-warning">
                <div className="mb-4" style={{ height: "46px" }}>
                  <IconTicketPaper
                    width="42px"
                    className="text-warning opacity-50"
                  />
                </div>
                <div className=" mb-4">تعداد بلیط</div>
                <div className="fw-bold fs-medium pb-2">
                  {isLoadingData ? (
                    <Skeleton width="40px" height="15px"></Skeleton>
                  ) : (
                    ctx?.basketInfo?.basketItemTemps.reduce(
                      (acc, current) => acc + current.totalCount,
                      0
                    )
                  )}
                </div>
              </div>
            </Col>
            <Col
              xs="12"
              sm="4"
              md
              lg="4"
              xl
              className="text-center mb-3  mb-sm-5 mb-xl-0"
            >
              <div className="border rounded-4 p-3 bg-light-info h-100 border-light-info">
                <div className="mb-4" style={{ height: "46px" }}>
                  <IconMoney width="42px" className="text-info opacity-50" />
                </div>
                <div className=" mb-4">قیمت نهایی </div>
                {isLoadingData ? (
                  <Skeleton width="100px" height="15px"></Skeleton>
                ) : (
                  <div className="fw-bold fs-medium pb-2">
                    <SplitNumber
                      number={ctx?.basketInfo?.basketItemTemps.reduce(
                        (acc, current) => acc + current.sumPrice,
                        0
                      )}
                    />
                  </div>
                )}
              </div>
            </Col>
            <Col
              xs="12"
              sm="4"
              md
              lg="4"
              xl
              className="text-center mb-3  mb-sm-5 mb-xl-0"
            >
              <div className="border rounded-4 p-3 bg-light-primary  border-light-primary">
                <div className="mb-4" style={{ height: "46px" }}>
                  <IconWallet
                    width="42px"
                    className="text-primary  opacity-50"
                  />
                </div>
                <div className="mb-4">اعتبار کیف پول</div>
                <div className="fw-bold fs-medium pb-2">
                  {isLoadingData ? (
                    <Skeleton width="100px" height="15px"></Skeleton>
                  ) : (
                    <SplitNumber number={dashboardData?.walletAmount} />
                  )}
                </div>
              </div>
            </Col>
            <Col
              xs="12"
              sm="4"
              md
              lg="4"
              xl
              className="text-center mb-3  mb-sm-5 mb-xl-0"
            >
              <div className="border rounded-4 p-3 bg-light-success h-100 border-light-success">
                <div className="mb-4" style={{ height: "46px" }}>
                  <IconCard width="42px" className="text-success opacity-75" />
                </div>
                <div className=" mb-4">مبلغ قابل پرداخت </div>
                <div className="fw-bold fs-medium pb-2">
                  {isLoadingData ? (
                    <Skeleton width="100px" height="15px"></Skeleton>
                  ) : dashboardData?.walletAmount >=
                    ctx?.basketInfo?.basketItemTemps.reduce(
                      (acc, current) => acc + current.sumPrice,
                      0
                    ) ? (
                    "0"
                  ) : (
                    <SplitNumber
                      number={
                        ctx?.basketInfo?.basketItemTemps.reduce(
                          (acc, current) => acc + current.sumPrice,
                          0
                        ) - dashboardData?.walletAmount
                      }
                    />
                  )}
                </div>
              </div>
            </Col>
          </Row>
          <Row className="mt-5  pt-5">
            {dashboardData?.walletAmount >=
            ctx?.basketInfo?.basketItemTemps.reduce(
              (acc, current) => acc + current.sumPrice,
              0
            ) ? (
              //  اگر شارژ کیف پول به اندازه مبلغ سفارش  بود-> کم شدن از کیف پول

              <Col className="text-center">
                <div className="bg-light-danger text-danger py-5 rounded-3 text-center fs-medium">
                  {isLoadingData ? (
                    <Skeleton width="80%" count={2} height="15px"></Skeleton>
                  ) : (
                    <>
                      <InfoOutlined className="mx-1" />
                      <span>مبلغ</span>
                      <span className="fw-bold px-2">
                        <SplitNumber
                          number={ctx?.basketInfo?.basketItemTemps.reduce(
                            (acc, current) => acc + current.sumPrice,
                            0
                          )}
                        />
                      </span>
                      <span>
                        تومان از کیف پول شما کسر خواهد شد. برای ثبت سفارش خود،
                        برروی دکمه «ثبت نهایی» کلیک نمایید.
                      </span>
                    </>
                  )}
                </div>
                {isLoadingData ? (
                  <Skeleton
                    width="200px"
                    height="38px"
                    className=" mt-5 py-3"
                  ></Skeleton>
                ) : (
                  <Button
                    className="btn border-danger mt-5 py-3 pulse-btn"
                    style={{ width: "200px" }}
                    onClick={handleGotoAfterPay}
                  >
                    ثبت نهایی
                  </Button>
                )}
              </Col>
            ) : dashboardData?.walletAmount < 1 ? (
              //  اگر شارژ کیف پول 0  بود -> ورود به درگاه

              <Col className="text-center">
                <div className="bg-light-danger text-danger py-5 rounded-3 text-center fs-medium">
                  {isLoadingData ? (
                    <Skeleton width="80%" count={2} height="15px"></Skeleton>
                  ) : (
                    <>
                      <InfoOutlined className="mx-1" />
                      <span>مبلغ نهایی پرداختی شما</span>
                      <span className="mx-1 fw-bold">
                        <SplitNumber
                          number={
                            ctx?.basketInfo?.basketItemTemps.reduce(
                              (acc, current) => acc + current.sumPrice,
                              0
                            ) - dashboardData?.walletAmount
                          }
                        />
                      </span>
                      تومان می باشد. برای ثبت سفارش خود، برروی دکمه «پرداخت»
                      کلیک نمایید.
                    </>
                  )}
                </div>
                {isLoadingData ? (
                  <Skeleton
                    width="200px"
                    height="38px"
                    className=" mt-5 py-3"
                  ></Skeleton>
                ) : (
                  <Button
                    className="btn border-danger mt-5 py-3 pulse-btn"
                    style={{ width: "200px" }}
                    onClick={handleGotoAfterPay}
                  >
                    پرداخت{" "}
                  </Button>
                )}
              </Col>
            ) : (
              // اگر کیف پول شارژ داشت اما از مبلغ نهایی کمتر بود -> ورود به درگاه

              <Col>
                <div className="bg-light-danger text-danger py-5 rounded-3 text-center fs-medium">
                  {isLoadingData ? (
                    <Skeleton width="80%" count={2} height="15px"></Skeleton>
                  ) : (
                    <>
                      <InfoOutlined className="mx-1" />
                      <SplitNumber number={dashboardData?.walletAmount} />
                      تومان از کیف پول شما کسر می گردد و مبلغ نهایی پرداختی شما
                      <span className="mx-1 fw-bold">
                        <SplitNumber
                          number={
                            ctx?.basketInfo?.basketItemTemps.reduce(
                              (acc, current) => acc + current.sumPrice,
                              0
                            ) - dashboardData?.walletAmount
                          }
                        />{" "}
                      </span>
                      تومان می شود.برای ثبت سفارش خود، برروی دکمه «پرداخت» کلیک
                      نمایید.
                    </>
                  )}
                </div>

                {isLoadingData ? (
                  <Skeleton
                    width="200px"
                    height="38px"
                    className=" mt-5 py-3"
                  ></Skeleton>
                ) : (
                  <Button
                    className="btn border-danger mt-5 py-3 pulse-btn"
                    style={{ width: "200px" }}
                    onClick={handleGotoAfterPay}
                  >
                    پرداخت{" "}
                  </Button>
                )}
              </Col>
            )}
          </Row>
        </div>
      </div>
    </SkeletonTheme>
  ) : (
    "آیتمی در سبد خرید شما وجود ندارد"
  );
}
